// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-53fb5038] .yes-no-centered-header .ag-header-cell-label{justify-content:center}", ""]);
// Exports
module.exports = exports;
